import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table, Tag } from 'antd';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import ReactApexChart from 'react-apexcharts';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Dashboard = (props) => {
  const navigate = useNavigate();
  const {user} = useAuth();
  const username = user.user;
  const [tasks, setTasks] = useState([]);
  const [totalTasks, setTotalTasks] = useState();
  const [inCompleteTask, setInCompleteTask] = useState();
  const [completedTask, setCompletedTask] = useState();
  const [inCompleteTaskCount, setInCompleteTaskCount] = useState();
  const [completedTaskCount, setCompletedTaskCount] = useState();

  // ====================== currentLocation code ===============================
  const [currentLocation, setCurrentLocation] = useState({ lat: 0, lng: 0 });
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      },
      (error) => {
        console.error('Error getting current location:', error);
      }
    );
  }, []);

  const center = {
    lat: currentLocation.lat,
    lng: currentLocation.lng
  };
  console.log("curentlocation==>", currentLocation, center);

  // ===========================================================================

  // ====================== Active Employee code ===============================
  const [activeEmployees, setActiveEmployees] = useState([]);
  const [activeUserCount, setActiveUserCount] = useState();

  useEffect(() => {
    let endpoint = API_URL + `/users/?filter=${username.username}`;
  
    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/users';
    }
  
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        // Filter out users with a valid punch_in and no punch_out
        const activeUsers = data.filter((user) => (user.punch_in !== null && user.punch_in !== undefined )&& (user.punch_out === null || user.punch_out === undefined || user.punch_out === ''));
        setActiveEmployees(activeUsers); // Set only active users
      })
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  useEffect (()=>{
    if(activeEmployees.length > 0){
      let activeUser = 0;
      activeUser = activeEmployees.length;
      setActiveUserCount(activeUser);
     } else {
      setActiveUserCount(0);
     }    
  },[activeEmployees])
  // ===========================================================================
  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        const completed = data.filter(task => task.status === 'Completed');
        const inComplete = data.filter(task => task.status === 'Pending');
        setTasks(data)
        setCompletedTask(completed)
        setInCompleteTask(inComplete)
      
      })
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue) => {
    let endpoint;

    if (filterValue && (username.role === 'Admin' || username.role === 'HR')) {
      endpoint = `${API_URL}/tasks/?assignee=&filter=${filterValue}`;
    } else if (filterValue){
      endpoint = `${API_URL}/tasks/?assignee=${username.username}&filter=${filterValue}`;
    }
    else if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = `${API_URL}/tasks/all`;
    } else {
      endpoint = `${API_URL}/tasks/?assignee=${username.username}`;
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        const completed = data.filter(task => task.status === 'Completed');
        const inComplete = data.filter(task => task.status === 'Pending');
        setTasks(data)
        setCompletedTask(completed)
        setInCompleteTask(inComplete)
      
      })
      .catch((error) => console.error(error));
  };

  useEffect (()=>{
    if(tasks.length > 0){
      let inCompleteCount = 0;
      let completedCount = 0;
      let totaltaskCount = 0;
      totaltaskCount = tasks.length;
      tasks.forEach(i=>{
        if(i.status === 'Pending') {
            inCompleteCount ++;
        } else if (i.status === "Completed") {
            completedCount++;
        }
      })
      setTotalTasks(totaltaskCount);
      setInCompleteTaskCount(inCompleteCount);
      setCompletedTaskCount(completedCount);
     } else {
      setTotalTasks(0);
      setInCompleteTaskCount(0);
      setCompletedTaskCount(0);
     }    
  },[tasks])

  const deleteTask = async (uuId) => {
    try {
      const response = await axios.delete(API_URL + `/tasks/${uuId}`);

      if (response.status === 204) {
        console.log('Task deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting task');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTasksDetailsByName = (uuId) => {
    const filteredTasks = tasks.filter(task => task.uuId === uuId);
    navigate('/ListViewInfo', { state: { taskDetails: filteredTasks[0] } });
  };

  const state = {
    series: [{
      data: [10, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 90],
      color:'#173452',
    }],
    options: { 
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          horizontal: false,
        }
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      }
    },
  };

  const containerStyle = {
    width: '37.2vw',
    height: '50vh',
    borderRadius: '1vw',
  };
  
  // const center = {
  //   lat: 37.7749,
  //   lng: -122.4194, // San Francisco coordinates, replace with your location
  // };
  
  const [isIsFormOpenFor_TotalActiveEmployee, setIsFormOpenFor_TotalActiveEmployee] = useState(false);
  const [isIsFormOpenFor_TotalTasks, setIsFormOpenFor_TotalTasks] = useState(false);
  const [isIsFormOpenFor_TotalTasksCompleted, setIsFormOpenFor_TotalTasksCompleted] = useState(false);
  const [isIsFormOpenFor_TotalPendingTasks, setIsFormOpenFor_TotalPendingTasks] = useState(false);

  const openForm1 = () => {
    setIsFormOpenFor_TotalActiveEmployee(true);
  };

  const closeForm1 = () => {
    setIsFormOpenFor_TotalActiveEmployee(false);
  };

  const openForm2 = () => {
    setIsFormOpenFor_TotalTasks(true);
  };

  const closeForm2 = () => {
    setIsFormOpenFor_TotalTasks(false);
  };

  const openForm3 = () => {
    setIsFormOpenFor_TotalTasksCompleted(true);
  };

  const closeForm3 = () => {
    setIsFormOpenFor_TotalTasksCompleted(false);
  };

  const openForm4 = () => {
    setIsFormOpenFor_TotalPendingTasks(true);
  };

  const closeForm4 = () => {
    setIsFormOpenFor_TotalPendingTasks(false);
  };

  const columns = [
    {
      title: 'Task',
      dataIndex: 'Task',
      key: 'Task',
      width: '8%',
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Priority',
      dataIndex: 'Priority',
      key: 'Priority',
      render: (_, { Priority }) => (
        <>
          {Priority.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'High') {
              color = '#761F1F';
            }
            else if (tag === 'Medium') {
              color = '#215115';
            }
            else if (tag === 'Low') {
              color='#A56D2B';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Status',
      key: 'Status',
      dataIndex: 'Status',
      render: (_, { Status }) => (
        <>
          {Status.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Pending') {
              color = '#761F1F';
            }
           else if (tag === 'Completed') {
              color = '#215115';
            }
            else if (tag === 'In-Process') {
              color='#A56D2B'
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      render: (_, { Role }) => (
        <>
          {Role && Role.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Admin') {
              color = '#173452';
            } else if (tag === 'HR') {
              color = '#173452';
            } else if (tag === 'Manager') {
              color = '#b5cce8';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    
    {
      title: 'Deadline',
      dataIndex: 'Deadline',
      key: 'Deadline',
      width: '11%',
    },
    {
      title: 'Action',
      key: 'action',
      width: '10%',
      render: (_, record) => (
        <Space size="middle">
           <div onClick={() => getTasksDetailsByName(record.uuId)}>
            <img className='search' src="../assets/pencil.png" alt="search" height={"24px"}></img>
          </div>
          <div onClick={() => deleteTask(record.uuId)}>
            <img className='search' src="../assets/trash.png" alt="search" height={"23px"}></img>
          </div>
        </Space>
      ),
    },
  ];
  const dataa = tasks.length > 0 ? tasks.map((item, index) => ({
    key: index.toString(),
    uuId: item.uuId,
    Task: index + 1,
    Name: item.assignee || '',
    Priority: [item.priority || ''],
    Status: [item.status || ''],
    Role: [item.role || ''],
    Deadline: item.deadline || '',
  })) : [];

  const ColumnsOf_TotalActiveEmployee = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno',
      key: 'Srno',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name2',
      key: 'Name2',
    },
  ];

  const dataOf_TotalActiveEmployee = activeEmployees.length > 0 ? activeEmployees.map((item, index) => ({
    key: index.toString(),
    Srno: index + 1,
    Name2: `${item.username} (${item.role}) ` || '',
  })) : [];

  const ColumnsOf_TotalTask = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno2',
      key: 'Srno2',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name3',
      key: 'Name3',
    },
    {
      title: 'Task Details',
      dataIndex: 'taskDetails',
      key: 'taskDetails',
    },
  ];

  const dataOf_TotalTask = tasks.length > 0 ? tasks.map((item, index) => ({
    key: index.toString(),
    Srno2: index + 1,
    Name3: item.assignee || '',
    taskDetails: item.taskDetails || '',
  })) : [];

  const ColumnsOf_TotalTaskCompleted = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno3',
      key: 'Srno3',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name4',
      key: 'Name4',
    },
    {
      title: 'Task Details',
      dataIndex: 'taskDetails',
      key: 'taskDetails',
    },
  ];

  const dataOf_TotalTaskCompleted = (completedTask && completedTask.length > 0 )? completedTask.map((item, index) => ({
    key: index.toString(),
    Srno3: index + 1,
    Name4: item.assignee || '',
    taskDetails: item.taskDetails || '',
  })) : [];


  const ColumnsOf_TotalPendingTask = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno4',
      key: 'Srno4',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name5',
      key: 'Name5',
    },
    {
      title: 'Task Details',
      dataIndex: 'taskDetails',
      key: 'taskDetails',
    },
  ];


  const dataOf_TotalPendingTask = (inCompleteTask && inCompleteTask.length > 0 )? inCompleteTask.map((item, index) => ({
    key: index.toString(),
    Srno4: index + 1,
    Name5: item.assignee || '',
    taskDetails: item.taskDetails || '',
  })) : [];


return( 
<div>
  <SideMenuBar></SideMenuBar>
    <div className="content">
      <NewHeader></NewHeader>
    
          <div className='row2'>
            <h3 className='dashboard_Dashboard'>Dashboard</h3>  
          </div>
        
          <div className='row3'>
            <div className='searchBox'>
              <div className="column1_searchBox">
                <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
              </div>
  
              <div className="column2_searchBox">
            <input className='search_input1' placeholder='Search' onChange={(e) => {
              const text = e.target.value;
              fetchTasks(text);
            }}></input>
              </div>
            </div>&nbsp;
            
            <select className='sort_by_Dashboard' name='' defaultValue= 'none'>
                <option value='none' disabled hidden>Sort by</option> 
                <option className='options_Dashboard'>Total Tasks</option>
                <option className='options_Dashboard'>Total Distance</option>
                <option className='options_Dashboard'>Total Days Present</option>
                <option className='options_Dashboard'>Total Days Absent</option>
                <option className='options_Dashboard'>Total Hours Worked</option>
            </select>
          </div>

          <div className="row4_Dashboard">
            <div className="column1_Dashboard" onClick={openForm1}>
                <p>Total Active Employees</p>
                <h3>{activeUserCount}</h3>
            </div>
            {isIsFormOpenFor_TotalActiveEmployee && (
              <>
              <div className="overlay_Dashboard" onClick={closeForm1}></div>
                <div className="popup-form_Dashboard">
                  <span className="close_Dashboard" onClick={closeForm1}>&times;</span>
                    <p><b>Total Active Employees</b></p><br/>
                    {/* Your form content goes here */}
                      <form>
                      {/* Form fields go here */}
                        <div>
                          <Table 
                            columns={ColumnsOf_TotalActiveEmployee} 
                            dataSource={dataOf_TotalActiveEmployee} 
                            scroll={{ y: 400 }}
                            pagination={false}
                          />
                        </div>      
                      </form>
                </div>
              </>
            )}

            <div className="column2_Dashboard" onClick={openForm2}>
                <p>Total Tasks</p>
                <h3>{totalTasks}</h3>
            </div>
            {isIsFormOpenFor_TotalTasks && (
              <>
              <div className="overlay_Dashboard" onClick={closeForm2}></div>
                <div className="popup-form_Dashboard">
                  <span className="close_Dashboard" onClick={closeForm2}>&times;</span>
                    <p><b>Total Tasks</b></p><br/>
                    {/* Your form content goes here */}
                      <form>
                      {/* Form fields go here */}
                        <div>
                          <Table 
                            columns={ColumnsOf_TotalTask} 
                            dataSource={dataOf_TotalTask} 
                            scroll={{ y: 400 }}
                            pagination={false}
                          />  
                        </div>      
                      </form>
                </div>
              </>
            )}
            
            <div className="column3_Dashboard" onClick={openForm3}>
                <p>Total Tasks Completed</p>
                <h3>{completedTaskCount}</h3>
            </div>
            {isIsFormOpenFor_TotalTasksCompleted && (
              <>
              <div className="overlay_Dashboard" onClick={closeForm3}></div>
                <div className="popup-form_Dashboard">
                  <span className="close_Dashboard" onClick={closeForm3}>&times;</span>
                    <p><b>Total Tasks</b></p><br/>
                    {/* Your form content goes here */}
                      <form>
                      {/* Form fields go here */}
                        <div>
                          <Table 
                            columns={ColumnsOf_TotalTaskCompleted} 
                            dataSource={dataOf_TotalTaskCompleted} 
                            scroll={{ y: 400 }}
                            pagination={false}
                          />
                        </div>      
                      </form>
                </div>
              </>
            )}

            <div className="column4_Dashboard" onClick={openForm4}>
                <p>Total Pending Tasks</p>
                <h3>{inCompleteTaskCount}</h3>
            </div>
            {isIsFormOpenFor_TotalPendingTasks && (
              <>
              <div className="overlay_Dashboard" onClick={closeForm4}></div>
                <div className="popup-form_Dashboard">
                  <span className="close_Dashboard" onClick={closeForm4}>&times;</span>
                    <p><b>Total Pending Tasks</b></p><br/>
                    {/* Your form content goes here */}
                      <form>
                      {/* Form fields go here */}
                        <div>
                          <Table 
                            columns={ColumnsOf_TotalPendingTask} 
                            dataSource={dataOf_TotalPendingTask} 
                            scroll={{ y: 400 }}
                            pagination={false}
                          />
                        </div>      
                      </form>
                </div>
              </>
            )}
          </div>

          <div className="row5_Dashboard">
            <div className="column1_row5_Dashboard">
              <LoadScript googleMapsApiKey="AIzaSyCbqg16HNi8_S2QFwBrXSW39G--VyfLj9s">
                <GoogleMap  mapContainerStyle={containerStyle} center={center} zoom={12} >
                <div className="custom-marker"></div>
                </GoogleMap>
              </LoadScript>
            </div>
            
            <div className="column2_row5_Dashboard">
              <ReactApexChart options={state.options} series={state.series} type="bar" height={'102%'}/>
            </div>
          </div>

          <div className='row6_Dashboard'>
            <p className='all_tasks_Dashboard'><b>All Tasks</b></p>
          </div>

          <div className='table_Dashboard'>
          {dataa && dataa.length > 0 ? (
  <Table 
    columns={columns} 
    dataSource={dataa} 
    scroll={{ y: 240 }}
    pagination={false}
  />
) : (
  <p>No tasks available</p>
)}
          </div>            

  <br/><br/>        
  </div>
</div>
 )
}

export default Dashboard;